import { MessageCircle } from "lucide-react";
import type { Product } from "../../types/content";
import { buildWhatsAppUrl } from "../../lib/whatsapp";
import { ImageSlot } from "../shared/ImageSlot";

export function ProductCard({ product }: { product: Product }) {
  const message = `Olá! Gostaria de consultar a disponibilidade de ${product.name}.`;
  return (
    <article className="product-card reveal">
      <ImageSlot slot={product.image} alt={product.name} aspect="square" />
      <div className="product-card__body">
        <div className="product-card__meta">
          <span>{product.category}</span>
          {product.madeToOrder && <span>Por encomenda</span>}
        </div>
        <h3>{product.name}</h3>
        <p>{product.description}</p>
        {product.availabilityNote && <small>{product.availabilityNote}</small>}
        <a href={buildWhatsAppUrl(message)} target="_blank" rel="noopener noreferrer" className="text-link">
          <MessageCircle size={17} aria-hidden="true" /> Consultar disponibilidade
        </a>
      </div>
    </article>
  );
}
